export default __webpack_public_path__ + "static/media/ruddy-1.519914c3.jpg";